import styled from '@emotion/styled';
import { colors, spacing, typography } from 'component-library';

export const StyledGroupedListContent = styled.div`
  display: flex;
  flex-flow: column;
`;

export const StyledLabel = styled.div<{ showBold: boolean; inactive: boolean }>`
  ${typography.body.large};
  ${({ showBold }) => showBold && typography.body.largeBold};
  ${({ inactive }) => inactive && `color: ${colors.primary.grey};`}
`;

export const Divider = styled.hr`
  border: 0;
  height: 1px;
  background-color: ${colors.monochrome.grey20};
  margin: 0;
`;

export const GroupLabel = styled.div`
  ${typography.body.largeBold};
  padding-top: ${spacing.xsmall};
  padding-bottom: ${spacing.tiny};
  padding-left: ${spacing.xsmall};
  padding-right: ${spacing.xsmall};
`;

export const LocationInfoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.xxsmall};
`;

export const LocationIconWrapper = styled.div`
  display: inline-flex;
  justify-content: center;
  flex-direction: column;
`;
